import React from "react";
import { Button } from "semantic-ui-react";
import FirstNameInput from "../../components/ValidatedFields/WithErrorLabel/FirstNameInput";
import LastNameInput from "../../components/ValidatedFields/WithErrorLabel/LastNameInput";
import ValidatorContext from "../../formvalidation/FormContext";
import { routes } from "utilities/routing/generatedRoutes";
import { useValidators } from "formvalidation/hooks";
import { useCurrentUser } from "common/SessionContext";

const ChangeNamePanelContent = () => {
  const currentUser = useCurrentUser();
  const [firstName, setFirstName] = React.useState(currentUser.firstName);
  const [lastName, setLastName] = React.useState(currentUser.lastName);
  const [isSaving, setIsSaving] = React.useState(false);

  const validators = useValidators();

  const onSave = async (e) => {
    e.preventDefault();

    const validationResult = await validators.validateAll();
    if (validationResult.hasErrors) {
      return;
    }
    setIsSaving(true);

    await window.CoreApi.Account.ChangeMyName({
      firstName,
      lastName
    });

    window.location.href = routes.personal_SettingMenu().absolute;
  };
  return <ValidatorContext settings={validators.validatorSettings}>
    <>
      <table className="s1_table clean rowspace">
        <tbody>
          <tr>
            <td>
              {RESX.Contact.FirstName}
            </td>
            <td>
              <FirstNameInput
                value={firstName}
                onChange={setFirstName}
                validatorKey="firstName"
              />
            </td>
          </tr>
          <tr>
            <td>
              {RESX.Contact.LastName}
            </td>
            <td>
              <LastNameInput
                value={lastName}
                onChange={setLastName}
                validatorKey="lastName"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <div className="flex justify-end margin-top-bigger">
        <Button
          primary
          loading={isSaving}
          disabled={isSaving}
          onClick={onSave}>
          {RESX.Buttons.btnSave}
        </Button>

      </div>
    </>
  </ValidatorContext>;
};

export default ChangeNamePanelContent;
